import { render, staticRenderFns } from "./parkingSpaceCreateFeeList.vue?vue&type=template&id=70293bab&scoped=true"
import script from "./parkingSpaceCreateFeeList.vue?vue&type=script&lang=js"
export * from "./parkingSpaceCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./parkingSpaceCreateFeeList.vue?vue&type=style&index=0&id=70293bab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70293bab",
  null
  
)

export default component.exports